import { ChangeDetectionStrategy, Component, Signal, ViewEncapsulation, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarComponent, AvatarMode } from '@workbuddy/ui/components/avatar';

@Component({
  selector: 'w-room-presence',
  templateUrl: 'room.presence.component.html',
  styleUrls: ['room.presence.component.less'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, AvatarComponent]
})
export class RoomPresenceComponent {

  public $room = input<{ $roomMembers?: Signal<readonly { _id: string; name: string }[]> } | null>(null, { alias: 'room' });
  public $limit = input(4, { alias: 'limit' });
  public $size = input(22, { alias: 'size' });

  protected readonly AvatarMode = AvatarMode;

  protected $members = computed(() => {

    const members = this.$room()?.$roomMembers?.();

    return Array.isArray(members) ? members : [];
  });
  protected $visibleMembers = computed(() => this.$members().slice(0, this.$limit()));
  protected $overflowCount = computed(() => Math.max(this.$members().length - this.$limit(), 0));
  protected $overflowLabel = computed(() => this.$overflowCount() ? `+${this.$overflowCount()}` : '');

  protected avatarValue(name: string): string {

    const normalized = (name ?? '').trim();
    if (!normalized) {
      return '';
    }

    // Preserve spaces so the avatar pipe can generate two initials.
    return normalized.split(/\s+/).join(' ');
  }
}
